export enum ReportConfigurationHeadersTerminology {
  reportLabel = 'Row 1: Top',
  subprojectName = 'Row 1: Bottom',
  projectLabel = 'Row 3 / Left: Top',
  projectName = 'Row 3 / Left: Bottom',
  clientLabel = 'Row 3 / Middle: Top',
  clientName = 'Row 3 / Middle: Bottom',
  onlineApproversLabel = 'Row 3 / Right: Top (locked for editing if online approvers are assigned)',
  onlineApproversStatus = 'Row 3 / Right: Bottom (locked for editing if online approvers are assigned)',
}
